module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-8-770b8613c9ce25b171be3dbc7e8af262.png";